module.exports = __webpack_public_path__ + "static/media/logo.9ae524ba.svg";